exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-157db919] .el-input__inner,[data-v-157db919] .el-textarea__inner {\n  border: none;\n  border-radius: 0;\n  resize: none;\n  padding-left: 0;\n  padding-right: 0;\n  border-bottom: 1px solid #d9d9d9;\n}\n.username[data-v-157db919] {\n  float: left;\n}\n.thanh[data-v-157db919] {\n  float: right;\n  margin-top: -60px;\n}\n.password[data-v-157db919] {\n  float: right;\n}\n[data-v-157db919] .el-dialog__title {\n  font-size: 25px;\n  color: #606266;\n}\n[data-v-157db919] .el-form-item__label {\n  font-family: Arial, Helvetica, sans-serif;\n}\n", ""]);

// exports
